/*=========================================================================================
  File Name: moduleSitesettingState.js
  Description: Site Setting State
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

export default {
  name: '',
  date_format: '',
  siteSettings: null,
  productSettings: {},
  defaultPurchase: '',
};
